import ButtonShare from "./button-share";

export default ButtonShare;